// extracted by mini-css-extract-plugin
module.exports = {"carServiceWhatYouGet":"_2sfXX","carServiceWrapper":"_1jjVp","carServiceCard":"_3cRy5","text":"_2aJvG","vehicleTitle":"snlnz"};